import { registerLicense, loadCldr, L10n } from "@syncfusion/ej2-base";
import french from "@syncfusion/ej2-cldr-data/main/fr/all.json";
import frNumberingSystem from "@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-icons/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-lists/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-calendars/styles/material.css";
import "@syncfusion/ej2-dropdowns/styles/material.css";
import "@syncfusion/ej2-react-schedule/styles/material.css";
import "@syncfusion/ej2-richtexteditor/styles/material.css";
import "@syncfusion/ej2-react-kanban/styles/material.css";

//Syncfusion License Key
registerLicense(
  // eslint-disable-next-line max-len
  "Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXZec3ZVQmJfVEF1Vks=",
);

// Load French translations for Syncfusion components
loadCldr(french, frNumberingSystem);

L10n.load({
  fr: {
    schedule: {
      day: "Jour",
      week: "Semaine",
      workWeek: "Semaine de travail",
      month: "Mois",
      year: "Année",
      agenda: "Ordre du jour",
      today: "Aujourd'hui",
      noEvents: "Aucun événement.",
    },
    calendar: {
      today: "Aujourd'hui",
    },
  },
});
